const celsiusToFahrenheit = (celc: number) => {
  return (celc * 9.0) / 5.0 + 32.0;
};

export default celsiusToFahrenheit;
